import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)
const router = new Router({
  routes: [
    {
      path: '/',
      name: 'Index',
      meta: {
        title: '首页-SELLER',
        headerShow: true,
        footerShow: true,
        leftShow: true,
        requireAuth: true,
      },
      component: () => import('@/pages/index/Index'),
    },
    {
      path: '/diy',
      name: 'Diy',
      meta: {
        title: 'diy建模-SELLER',
        headerShow: true,
        footerShow: true,
        leftShow: true,
        requireAuth: true,
        requireAdmin: true,
      },
      component: () => import('@/pages/diy/Index'),
    },
    {
      path: '/factory',
      name: 'Factory',
      meta: {
        title: '工厂生产-SELLER',
        headerShow: true,
        footerShow: true,
        leftShow: true,
        requireAuth: false,
      },
      component: () => import('@/pages/factory/Index'),
    },
    {
      path: '/goods',
      name: 'Goods',
      meta: {
        title: '商品-SELLER',
        headerShow: true,
        footerShow: true,
        leftShow: true,
        requireAuth: false,
      },
      component: () => import('@/pages/goods/Index'),
    },
    {
      path: '/goods/edit',
      name: 'GoodsEdit',
      meta: {
        title: '发布商品-SELLER',
        headerShow: true,
        footerShow: true,
        leftShow: true,
        requireAuth: true,
        requireAdmin: false,
      },
      component: () => import('@/pages/goods/Edit'),
    },
    {
      path: '/goods/detail',
      name: 'Goodsdetail',
      meta: {
        title: '商品详情-SELLER',
        headerShow: true,
        footerShow: true,
        leftShow: true,
        requireAuth: true,
        requireAdmin: false,
      },
      component: () => import('@/pages/goods/Detail'),
    },
    {
      path: '/crop',
      name: 'Crop',
      meta: {
        title: '素材-SELLER',
        headerShow: true,
        footerShow: true,
        leftShow: true,
        requireAuth: true,
        requireAdmin: false,
      },
      component: () => import('@/pages/crop/Index'),
    },
    {
      path: '/orders',
      name: 'Orders',
      meta: {
        title: '订单-SELLER',
        headerShow: true,
        footerShow: true,
        leftShow: true,
        requireAuth: false,
      },
      component: () => import('@/pages/orders/Index'),
    },
    {
      path: '/orders/visitor',
      name: 'Visitor',
      meta: {
        title: '订单-SELLER',
        headerShow: true,
        footerShow: true,
        leftShow: true,
        requireAuth: false,
      },
      component: () => import('@/pages/orders/visitor/Index'),
    },
    {
      path: '/orders/customer',
      name: 'Customer',
      meta: {
        title: '客户-SELLER',
        headerShow: true,
        footerShow: true,
        leftShow: true,
        requireAuth: false,
      },
      component: () => import('@/pages/orders/customer/Index'),
    },
    {
      path: '/orders/detail',
      name: 'Ordersdetail',
      meta: {
        title: '订单详情-SELLER',
        headerShow: true,
        footerShow: true,
        leftShow: true,
        requireAuth: false,
      },
      component: () => import('@/pages/orders/Detail'),
    },
    {
      path: '/orders/diy-create',
      name: 'DiyCreate',
      meta: {
        title: 'DIY作品-SELLER',
        headerShow: true,
        footerShow: true,
        leftShow: true,
        requireAuth: true,
        requireAdmin: true,
      },
      component: () => import('@/pages/orders/create/Index'),
    },
    {
      path: '/orders/order-create',
      name: 'OrderCreate',
      meta: {
        title: '订单图库-SELLER',
        headerShow: true,
        footerShow: true,
        leftShow: true,
        requireAuth: true,
        requireAdmin: true,
      },
      component: () => import('@/pages/orders/orderCreate/Index'),
    },
    {
      path: '/orders/diy-prompt',
      name: 'OrderPrompt',
      meta: {
        title: '绘画特效-SELLER',
        headerShow: true,
        footerShow: true,
        leftShow: true,
        requireAuth: true,
        requireAdmin: true,
      },
      component: () => import('@/pages/orders/prompt/Index'),
    },
    {
      path: '/orders/submit',
      name: 'OrderSubmit',
      meta: {
        title: '定制提交-SELLER',
        headerShow: true,
        footerShow: true,
        leftShow: true,
        requireAuth: true,
        requireAdmin: true,
      },
      component: () => import('@/pages/orders/submit/Index'),
    },
    {
      path: '/orders/cart',
      name: 'OrdersCart',
      meta: {
        title: '购物车-SELLER',
        headerShow: true,
        footerShow: true,
        leftShow: true,
        requireAuth: true,
        requireAdmin: true,
      },
      component: () => import('@/pages/orders/cart/Index'),
    },
    {
      path: '/orders/cart/preview',
      name: 'OrdersCartPreview',
      meta: {
        title: '购物车预览图-SELLER',
        headerShow: true,
        footerShow: true,
        leftShow: true,
        requireAuth: true,
        requireAdmin: true,
      },
      component: () => import('@/pages/orders/cart/Preview'),
    },
    {
      path: '/orders/abandoned',
      name: 'OrdersAbandoned',
      meta: {
        title: '弃单-SELLER',
        headerShow: true,
        footerShow: true,
        leftShow: true,
        requireAuth: true,
        requireAdmin: true,
      },
      component: () => import('@/pages/orders/abandoned/Index'),
    },
    {
      path: '/orders/upload-files',
      name: 'UploadFiles',
      meta: {
        title: '图库-SELLER',
        headerShow: true,
        footerShow: true,
        leftShow: true,
        requireAuth: true,
        requireAdmin: true,
      },
      component: () => import('@/pages/orders/UploadFiles'),
    },
    {
      path: '/logistics',
      name: 'Logistics',
      meta: {
        title: '物流管理-SELLER',
        headerShow: true,
        footerShow: true,
        leftShow: true,
        requireAuth: true,
      },
      component: () => import('@/pages/logistics/Index'),
    },
    {
      path: '/activity',
      name: 'Activity',
      meta: {
        title: '活动-SELLER',
        headerShow: true,
        footerShow: true,
        leftShow: true,
        requireAuth: true,
        requireAdmin: true,
      },
      component: () => import('@/pages/activity/Index'),
    },
    {
      path: '/refund',
      name: 'Refund',
      meta: {
        title: '退款-SELLER',
        headerShow: true,
        footerShow: true,
        leftShow: true,
        requireAuth: true,
        requireAdmin: true,
      },
      component: () => import('@/pages/refund/Index'),
    },
    {
      path: '/customers',
      name: 'Customers',
      meta: {
        title: '客户-SELLER',
        headerShow: true,
        footerShow: true,
        leftShow: true,
        requireAuth: true,
        requireAdmin: true,
      },
      component: () => import('@/pages/customers/Index'),
    },
    {
      path: '/customers/detail',
      name: 'CustomersDetail',
      meta: {
        title: '客户信息-SELLER',
        headerShow: true,
        footerShow: true,
        leftShow: true,
        requireAuth: true,
        requireAdmin: true,
      },
      component: () => import('@/pages/customers/Detail'),
    },
    {
      path: '/sign',
      name: 'Sign',
      meta: {
        title: '登录-SELLER',
        headerShow: true,
        footerShow: true,
        requireAuth: false,
      },
      component: () => import('@/pages/sign/Index'),
    },
    {
      path: '/users/profile',
      name: 'UsersProfile',
      meta: {
        title: '我的资料-SELLER',
        headerShow: true,
        footerShow: true,
        leftShow: true,
        requireAuth: true,
      },
      component: () => import('@/pages/users/Profile'),
    },
    {
      path: '/setting',
      name: 'SettingIndex',
      meta: {
        title: '设置-SELLER',
        headerShow: true,
        footerShow: true,
        leftShow: true,
        requireAuth: true,
        requireAdmin: true,
      },
      component: () => import('@/pages/setting/Index'),
    },
    {
      path: '/privacy-policy',
      name: 'PrivacyPolicy',
      meta: {
        title: 'PrivacyPolicy-SELLER',
        headerShow: true,
        footerShow: true,
        requireAuth: false,
        requireAdmin: true,
      },
      component: () => import('@/pages/policy/PrivacyPolicy'),
    },
    {
      path: '/faq',
      name: 'FAQ',
      meta: {
        title: 'FAQ-SELLER',
        headerShow: true,
        footerShow: true,
        requireAuth: false,
        requireAdmin: true,
      },
      component: () => import('@/pages/policy/FAQ'),
    },
    {
      path: '/about-us',
      name: 'AboutUs',
      meta: {
        title: 'About Us-SELLER',
        headerShow: true,
        footerShow: true,
        requireAuth: false,
        requireAdmin: true,
      },
      component: () => import('@/pages/policy/AboutUs'),
    },
    {
      path: '/tutorial',
      name: 'Tutorial',
      meta: {
        title: 'Tutorial-SELLER',
        headerShow: true,
        footerShow: true,
        requireAuth: false,
        requireAdmin: true,
      },
      component: () => import('@/pages/policy/Tutorial'),
    },
    {
      path: '/screencast-video',
      name: 'ScreencastVideo',
      meta: {
        title: 'Screencast Video-SELLER',
        headerShow: true,
        footerShow: true,
        requireAuth: false,
        requireAdmin: true,
      },
      component: () => import('@/pages/policy/ScreencastVideo'),
    },
    {
      path: '/email',
      name: 'email',
      meta: {
        title: 'email-SELLER',
        headerShow: true,
        footerShow: true,
        leftShow: true,
        requireAuth: false,
        requireAdmin: true,
      },
      component: () => import('@/pages/email/Index'),
    },
    {
      path: '/email/templates',
      name: 'EmailTemplates',
      meta: {
        title: 'EmailTemplates-SELLER',
        headerShow: true,
        footerShow: true,
        leftShow: true,
        requireAuth: false,
        requireAdmin: true,
      },
      component: () => import('@/pages/email/Templates'),
    },
    {
      path: '/email/detail',
      name: 'EmailDetail',
      meta: {
        title: 'EmailDetail-SELLER',
        headerShow: true,
        footerShow: true,
        leftShow: true,
        requireAuth: false,
        requireAdmin: true,
      },
      component: () => import('@/pages/email/Detail'),
    },
    {
      path: '/marketing',
      name: 'marketing',
      meta: {
        title: 'marketing-SELLER',
        headerShow: true,
        footerShow: true,
        leftShow: true,
        requireAuth: false,
        requireAdmin: true,
      },
      component: () => import('@/pages/marketing/Index'),
    },
  ],
  mode: 'history',
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(res => res.meta.requireAuth)) {
    if (to.meta.hasOwnProperty('requireAdmin') && to.meta.requireAdmin) { 
      var uid = parseInt(localStorage.getItem('uid'));
      if (uid !== 1) { 
        console.log("权限不足。。。。。。。。。。。。")
        next({
          path: '/',
          query: { redirect: to.fullPath }
        })
        return;
      }
    }
    if (localStorage.getItem('token')) {
      next()
    } else {
      next({
        path: '/sign?a=from_route',
        query: { redirect: to.fullPath }
      })
    }
  } else {
    next()
  }
})
router.afterEach(function (to, from) {
  if (to.meta.title) {
    document.title = to.meta.title;
  }
});

export default router;


// WEBPACK FOOTER //
// ./src/router/index.js